import { render, staticRenderFns } from "./FacetInputRadio.vue?vue&type=template&id=0120ab50&"
import script from "./FacetInputRadio.vue?vue&type=script&lang=ts&"
export * from "./FacetInputRadio.vue?vue&type=script&lang=ts&"
import style0 from "./FacetInputRadio.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports